import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import {Typography} from "@mui/material";
import Grid from "@mui/material/Grid";
import DialogButtonRegistration from "../../components/DialogButtonRegistration/DialogButtonRegistration";

const OrganizersPage: React.FC = () => {

    return(
        <>
            <CssBaseline />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '80vh',
                }}
            >
                <Box sx={{ maxWidth: 800, margin: '0 auto', padding: 2 }}>
                    <Typography variant="h2" gutterBottom>
                        Организатор
                    </Typography>

                    <Grid container spacing={{ xs: 2, md: 3 }}>
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}  >
                            <Box sx={{ width: 320, height: 320, backgroundColor: 'lightgray', textAlign: 'center' }}>
                                <img
                                    src="/MyFoto.jpg"
                                    alt="Александр Бердышев"
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}  >
                            <Typography variant="body1" paragraph>
                                Меня зовут Александр Бердышев, я инженер данных, аналитик данных, дата сайнтист.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                Уже лет 5 пробую делать свои проекты и уже имею достаточно обширный опыт в этом.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                Агитирую всех прекращать работать в найме и пробовать начинать работать на себя.
                            </Typography>
                            <Typography variant="body1" paragraph>
                                Если у вас есть какие-то вопросы, написать мне вы можете <a href="https://t.me/Alexander_Berdyshev" target="_blank" rel="noopener noreferrer">тут</a>
                            </Typography>
                        </Grid>
                    </Grid>

                </Box>
            </Box>
        </>
    )
}

export default OrganizersPage;